/**
 * Restructed by he.zhikai
 * Restructed on 2017-11-17
 */
'use strict';
angular.module('connectPassageModule', []).
controller('connectPassageCtrl', ["$scope", "$validation", "$state", "$modalInstance", "$timeout", "modalDialog", "report", "editcenterRightsService",
    function($scope, $validation, $state, $modalInstance, $timeout, modalDialog, report, editcenterRightsService) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                report: report,
                type: 0,
                news: {
                    ReportId: report.NEWREPORTID,
                    Title: '',
                    Url: ''
                }
            };
        }

        /**
         * [createNews description] 在我的中创建
         * @return {[type]} [description]
         */
        $scope.createNews = function() {
            editcenterRightsService.initIwoListBtn("iwo.personal").then(function(rights) {
                if(rights["iwo.personal.xinjian"]) {
                    $modalInstance.dismiss();
                    var url = $state.href("reportsummarynews", {
                        iwoplatform: 0,
                        reportId: $scope.data.report.NEWREPORTID
                    });
                    window.open(url);
                } else {
                    modalDialog.alertType("当前用户没有新建稿件的权限！", "", "error", false);
                }
            });
        };

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 确定
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.connectPassageForm.$pending = {};
            $validation.validate($scope.connectPassageForm).success(function() {
                $modalInstance.close($scope.data.news);
            }).error(function() {
                $timeout(function() {
                    modalDialog.alertType("提交失败", "请检查填写项", "error", false);
                }, 300);
            });
        };
    }
]);